export default {
  /* --- SUPERUSER URL --- */
  "superuser-update-profile": "User/Update/Superuser/",
  "superuser-update-password": "User/Update/Superuser/Password/",

  // City
  "read-city-non-cov-autocomplete": "Master/City-Non-Coverage/Autocomplete/",
  "read-city-in-cov-autocomplete": "Master/City-In-Coverage/Autocomplete/",
  "read-city-all-autocomplete": "Master/City/Autocomplete/",
  "read-city-all-master": "Master/City/Master/",

  /**
  |--------------------------------------------------
  | Master
  |--------------------------------------------------
  */

  // Asset
  "read-asset": "Asset/",
  "read-asset-info": "Asset/Info/",
  "read-asset-global": "Asset/Info/Global/",
  "read-asset-autocomplete": "Asset/Autocomplete/",
  "read-make-autocomplete": "Autocomplete/Asset/Assets/Make/",
  "read-model-autocomplete": "Autocomplete/Asset/Assets/Model/",
  "move-asset": "Asset/Move/{}/",
  "check-tag": "Asset/Tag-Checker/{}/",

  // Currency
  "read-currency-autocomplete": "Master/Currency/Autocomplete/",

  // Location
  "read-location": "Location/",
  "register-location": "Location/Register/",
  "update-location": "Location/Update/{}/",
  "delete-location": "Location/Delete/{}/",
  "read-location-autocomplete": "Location/Autocomplete/",

  // Site Location
  "read-site": "Location/Sites/",
  "register-site": "Location/Site/Register/",
  "update-site": "Location/Site/Update/{}/",
  "read-site-autocomplete": "Location/Sites/Autocomplete/",

  // Site Coverage
  "read-coverage": "Tenant/City/Coverages/",
  "register-coverage": "Tenant/City/Coverage/Register/",

  // Asset Status
  "read-asset-status": "Master/AssetsStatus/",
  "register-asset-status": "Master/AssetStatus/Register/",
  "update-asset-status": "Master/AssetStatus/Update/{}/",
  "delete-asset-status": "Master/AssetStatus/Delete/{}/",
  "read-asset-status-master": "Master/Asset-Status-Master/",
  "read-asset-status-autocomplete": "Master/AssetsStatus/Autocomplete/",

  // Asset Type
  "read-asset-type": "Master/AssetTypes/",
  "register-asset-type": "Master/AssetType/Register/",
  "update-asset-type": "Master/AssetType/Update/{}/",
  "delete-asset-type": "Master/AssetType/Delete/{}/",
  "read-asset-type-master": "Master/Asset-Type-Master",
  "read-asset-type-autocomplete": "Master/AssetTypes/Autocomplete/",

  // Contact
  "read-contact": "Master/Contacts/",
  "register-contact": "Master/Contact/Register/",
  "update-contact": "Master/Contact/Update/{}/",
  "delete-contact": "Master/Contact/Delete/{}/",
  "read-contact-autocomplete": "Master/Contacts/Autocomplete/",

  // Contractor
  "read-contractor": "Master/Contractor/",
  "register-contractor": "Master/Contractor/",
  "update-contractor": "Master/Contractor/{}/",
  "delete-contractor": "Master/Contractor/{}/",
  "detail-contractor": "Master/Contractor/{}/",
  "read-contractor-autocomplete": "Master/Contractor/Autocomplete/",

  // Department
  "read-department": "Master/Departements/",
  "register-department": "Master/Departement/Register/",
  "update-department": "Master/Departement/Update/{}/",
  "delete-department": "Master/Departement/Delete/{}/",

  // Site Status
  "read-site-status": "Master/SitesStatus/",
  "register-site-status": "Master/SiteStatus/Register/",
  "update-site-status": "Master/SiteStatus/Update/{}/",
  "delete-site-status": "Master/SiteStatus/Delete/{}/",
  "read-site-status-autocomplete": "Master/SitesStatus/Autocomplete/",

  // Site Type
  "read-site-type": "Master/SiteTypes/",
  "register-site-type": "Master/SiteType/Register/",
  "update-site-type": "Master/SiteType/Update/{}/",
  "delete-site-type": "Master/SiteType/Delete/{}/",
  "read-site-type-autocomplete": "Master/SiteTypes/Autocomplete/",

  // Maintenance Type
  "read-maintenance-type": "Maintenance/Service/",
  "register-maintenance-type": "Maintenance/Service/Register/",
  "update-maintenance-type": "Maintenance/Service/Update/{}/",
  "delete-maintenance-type": "Maintenance/Service/Delete/{}/",
  "detail-maintenance-type": "Maintenance/Service/Detail/{}/",
  "read-maintenance-type-master": "Maintenance/Service/Master/",
  "read-maintenance-type-autocomplete": "Maintenance/Service/Autocomplete/",

  // Vendor
  "read-vendor-autocomplete": "Master/Vendor/Autocomplete/",

  // User
  "read-user": "User/",
  "register-user": "User/Register/",
  "update-user": "User/Update/Information/{}/",
  "update-user-password": "User/Update/Password/{}/",
  "delete-user": "User/Delete/{}/",
  "read-user-master": "User/Master/",
  "read-user-autocomplete": "User/Autocomplete/",
  "upload-user-photo": "User/Me/Photo/",
  "verivication-user":"User/register/{}/",

  // Role
  "read-role": "User/Roles/",
  "register-role": "User/Role/Register/",
  "update-role": "User/Role/Update/{}/",
  "delete-role": "User/Role/Delete/{}/",
  "read-role-autocomplete": "User/Roles/Autocomplete/",

  // Job Stock
  "read-job-stock": "Report/StockTake/",
  "register-job-stock": "Report/StockTake/",

  // Job Stock Details
  "read-job-stock-details": "Report/StockTake/Details/",
  "mark-as-exist": "Report/StockTake/Details/Available/",

  // SUPERUSER
  "read-city-autocomplete": "Master/City/Autocomplete/",
  "read-province-autocomplete": "Master/Province/Autocomplete/",
  "read-country-autocomplete": "Master/Country/Autocomplete/",
  "read-bussiness-autocomplete": "Master/BusinessModel/Autocomplete/",

  // Notes
  "read-notes": "v1/asset/{}/notes/",

  // Logo
  "update-login-logo": "Tenant/Config/Update/LoginLogo/",
  "update-dashboard-logo": "Tenant/Config/Update/DashboardLogo/",
  "update-report-logo": "Tenant/Config/Update/ReportLogo/",

  // delete
  "delete-login-logo": "Tenant/Config/Logo/Login/",
  "delete-dashboard-logo": "Tenant/Config/Logo/Dashboard/",
  "delete-report-logo": "Tenant/Config/Logo/Report/",

  // sumary Logo
  "get-summary-logo": "Tenant/Config/Summary/",

  "register-booking": "Booking/Reservation/Register/",

  /**
  |--------------------------------------------------
  | URL LIST FOR SUPERUSER
  |--------------------------------------------------
  */
  "read-bussines-all": "Master/BusinessModel/All/",
  "read-bussines": "Master/BusinessModels/",
  "register-bussines": "Master/BusinessModel/Register/",
  "update-bussines": "Master/BusinessModel/Update/{}/",

  "read-currency": "Master/Currency/",
  "register-currency": "Master/Currency/",
  "update-currency": "Master/Currency/{}/",

  "read-country": "Master/Country/",
  "read-country-all": "Master/Country/All/",
  "register-country": "Master/Country/",
  "update-country": "Master/Country/{}/",

  "read-province": "Master/Province/",
  "read-province-all": "Master/Province/All/",
  "register-province": "Master/Province/",
  "update-province": "Master/Province/{}/",

  "read-city": "Master/City/",
  "read-city-all": "Master/City-Master/",
  "register-city": "Master/City/",
  "update-city": "Master/City/{}/",

  "read-tenant": "Tenant/",
  "register-tenant": "Tenant/Create/",
  "update-tenant": "Tenant/Update/{}/",

  /**
  |--------------------------------------------------
  | IMPROVED API 29-maret-2019
  |--------------------------------------------------
  */
  "improved-read-asset": "v1/asset/list/",
  "improved-read-asset-idle": "v1/asset/idle/",
  "improved-read-asset-unavailable": "v1/asset/unavailable/",
  "read-asset-detail": "v1/asset/{}/detail/",
  "read-asset-purchase": "v1/asset/{}/purchase/",
  "read-asset-reservation": "v1/asset/{}/reservations/",
  "read-asset-maintenance": "v1/asset/{}/maintenance/",
  "read-maintenance-by-asset": "v1/asset/admin/{}/maintenance/",
  "check-version": "system/version"
};



// WEBPACK FOOTER //
// ./src/App/config/url.js